import BigButton from "components/atoms/buttons/BigButton";
import * as s from "../LoginStyled";
import { LOGIN_STEP, LOGIN_TAB } from "../LoginContainer";
import { MYDW_LOGO } from "components/blocks/sidenav/TopInfo";
import { useIsMobile } from "components/MediaQuery";

interface Props {
  onChangeStep: (step: LOGIN_STEP) => void;
}
export default function ResellerInfo({ onChangeStep }: Props) {
  const isMobile = useIsMobile();
  return (
    <s.SignUpWrapper>
      {!isMobile && (
        <s.LoginCopy>
          Proactive health monitoring for all your DW surveillance solutions
          from a single, cloud-based, user-friendly dashboard.
        </s.LoginCopy>
      )}

      <h3>
        <span>New to myDW?</span>
      </h3>
      <BigButton
        buttonType="cancel"
        label="Start Your Free Trial!"
        onClickBtn={() => {
          //여기에서 테스트 하세요
          // navigate("/reseller", {
          //   state: { email: "min.lee@mydw.com", userType: USER_TYPE.NOT_SALESFORCE_USER },
          // });
          onChangeStep(LOGIN_STEP.FREE_TRIAL);
        }}
        data-testid="auth-signin-common-button-change-step"
      />

      <s.LoginInfo tab={LOGIN_TAB.EMAIL}>
        <s.CpIcon>CP</s.CpIcon>
        <h3>
          Become a{" "}
          <img
            src={MYDW_LOGO}
            width="120"
            alt="MyDW Icon"
            className="mydw-logo"
          />{" "}
          Reseller
        </h3>
        <p>
          As a reseller, you can manage all your clients from a single
          dashboard, offer remote health monitoring, and ensure each client’s
          data remains securely isolated.
        </p>
        <button
          onClick={() => onChangeStep(LOGIN_STEP.RESELLER)}
          data-testid="auth-signin-common-button-change-step"
        >
          Join the myDW partner network today.
        </button>
      </s.LoginInfo>
    </s.SignUpWrapper>
  );
}
